export default "__VITE_ASSET__fac64efb__"